import { useTranslation } from '../../../i18n/TranslationContext';

export default function BrandHero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20dragon%20fruit%20inspired%20composition%20with%20vivid%20hot%20magenta%20pink%20and%20fresh%20green%20accents%2C%20soft%20cream%20white%20background%2C%20flowing%20organic%20curves%2C%20modern%20editorial%20aesthetic%2C%20global%20business%20theme%2C%20warm%20atmospheric%20gradient&width=1800&height=1000&seq=brands-hero-2026&orientation=landscape"
          alt="Brands"
          className="w-full h-full object-cover object-top opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-24">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/30 backdrop-blur-md text-background-50 text-xs font-medium mb-6 md:mb-8 border border-primary-300/40 whitespace-nowrap tracking-wide">
            {t('brands.hero.tagline')}
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-heading text-background-50 leading-[1.05] mb-6 md:mb-8">
            {t('brands.hero.title_line1')}
            <br />
            {t('brands.hero.title_line2')}
          </h1>
          <p className="text-background-50/80 text-sm md:text-base max-w-xl leading-relaxed mb-8 md:mb-10">
            {t('brands.hero.description')}
          </p>
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = '/#contact';
            }}
            className="px-7 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
          >
            {t('brands.hero.cta')}
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}